import { render } from "./MainConsolidatedSales.vue?vue&type=template&id=53f782eb&scoped=true"
import script from "./MainConsolidatedSales.vue?vue&type=script&lang=js"
export * from "./MainConsolidatedSales.vue?vue&type=script&lang=js"

import "./MainConsolidatedSales.vue?vue&type=style&index=0&id=53f782eb&scoped=true&lang=css"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f782eb"]])

export default __exports__